import React from 'react';

// Composants
import Title from '../../components/Title/Title';
import ContentText from '../../components/content/content-text.jsx';
import SimpleTitle from '../../components/Title/SimpleTitle';
import Content from '../../components/content/content';
import ContentSlider from '../../components/content/content-slider';
import Skills from '../../components/Projects/Skills.jsx';

// Contenus
import aidadom from '../../assets/content/projets/aidadom.json';

const Aidadom = () => {
    return (
        <div className='projet'>
            <div className="bloc">
                <Title title={aidadom.title} variant={aidadom.variant} />
                <ContentText content={aidadom.description} />

                <div className='content'>
                    <SimpleTitle title="Ma démarche" variant="green" position="left" />
                    
                    <ContentSlider
                        content={aidadom.partie1}
                        images={aidadom.slider1}
                        cote="left"
                    />
                    
                    <ContentSlider
                        content={aidadom.partie2}
                        images={aidadom.slider2}
                        cote="right"
                    />

                    <div className='content-text'>
                        <ContentText content={aidadom.partie3} />
                    </div>
                </div>
            </div>

            <div className='skills bloc'>
                <SimpleTitle title="Technologies utilisées" variant="white" position="left" />
                <div className='skills-grid'>
                    {aidadom.technologies.map((tech, index) => (
                        <Skills
                            key={index}
                            image={tech.image}
                            alt={tech.alt}
                            competence={tech.name}
                            centered={tech.bool}
                        />
                    ))}
                </div>
            </div>

            <div className='competences bloc'>
                <SimpleTitle title="Compétences et apprentissages critiques mobilisés" variant="purple" position="left" />
                <Content
                    content={aidadom.competences}
                    image={{thumb: aidadom.imgcompetences,hd: aidadom.imgcompetences}} alt={aidadom.altcompetencesgrd} cote={"left"} width={aidadom.widthcompetences} height={aidadom.heightcompetences} title="Illustration des compétences"
                />
            </div>
        </div>
    );
};

export default Aidadom;
